/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateAdviserLinkDto = {
    /**
     * Type of adviser link
     */
    linkType: CreateAdviserLinkDto.linkType;
    /**
     * Adviser ID
     */
    adviserId: string;
    /**
     * FAP ID
     */
    fapId: string;
    /**
     * Effective from date (ISO 8601). If omitted, API defaults to current date in NZT.
     */
    effectiveFrom?: string;
    /**
     * Effective to date (ISO 8601). Leave blank if ongoing
     */
    effectiveTo?: string;
    /**
     * Commission recipient type
     */
    commissionRecipient: CreateAdviserLinkDto.commissionRecipient;
    /**
     * Reason for this adviser link change
     */
    reason: string;
};
export namespace CreateAdviserLinkDto {
    /**
     * Type of adviser link
     */
    export enum linkType {
        AUTHORISED_REP = 'AUTHORISED_REP',
        SERVICING_ADVISER = 'SERVICING_ADVISER',
    }
    /**
     * Commission recipient type
     */
    export enum commissionRecipient {
        ADVISER = 'ADVISER',
        FAP = 'FAP',
        INHERIT = 'INHERIT',
    }
}

